import {
  DashboardPage,
  AudienceLibraryPage,
  AudienceUpload,
  CreateCampaignPage,
  ChildOrgsPage,
  CreativesLibraryPage,
  OrgSettingsPage,
  SuccessPage,
  ThemeSelectionPage,
  PlaceholderPage,
  BillingPage,
  TestPage,
  SearchPage,
  DocumentationPage,
  InternalAPIDocsPage,
  PixelViewPage,
  PixelLibraryPage,
  ReportHubOverviewPage,
  ReleaseNotePage,
  AUPPage,
  DPAPage,
} from './Pages'

import { PixelSubscriptionsPage } from './Pages/PixelSubscriptionsPage'
import {
  RouteObject,
  Navigate,
  useSearchParams,
  useLocation,
} from 'react-router-dom'

// Component to redirect to overview while preserving query parameters
const ReportHubRedirect = () => {
  const [searchParams] = useSearchParams()
  const queryString = searchParams.toString()
  const to = queryString ? `overview?${queryString}` : 'overview'
  return <Navigate to={to} replace />
}

// Component to redirect from /report-hub to /advanced-reporting
const ReportHubToAdvancedReportingRedirect = () => {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const queryString = searchParams.toString()

  // Extract the sub-path after /report-hub
  const subPath = location.pathname.replace('/report-hub', '')
  const newPath = `/advanced-reporting${subPath}`
  const to = queryString ? `${newPath}?${queryString}` : newPath

  return <Navigate to={to} replace />
}

export const authorizedRoutes: RouteObject[] = [
  { path: '/', element: <DashboardPage /> },
  { path: '/theme-info', element: <ThemeSelectionPage /> },
  { path: '/test-page', element: <TestPage /> },
  {
    path: '/audiences',
    children: [
      { path: 'create', element: <AudienceUpload /> },
      {
        path: 'audience-library',
        element: <AudienceLibraryPage />,
        children: [
          {
            path: ':audienceId',
            element: <AudienceLibraryPage />,
            children: [
              { path: 'notes/:noteId', element: <AudienceLibraryPage /> },
            ],
          },
        ],
      },

      { path: 'marketplace', element: <PlaceholderPage /> },
    ],
  },
  {
    path: '/campaigns',
    children: [
      {
        path: ':campaignId',
        children: [
          {
            path: 'success',
            element: <SuccessPage />,
          },
        ],
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
        children: [
          { path: ':campaignId', element: <DashboardPage /> },
          { path: 'order-lines/:orderLineId', element: <DashboardPage /> },
        ],
      },
      {
        path: 'creative-library',
        element: <CreativesLibraryPage />,
        children: [{ path: ':creativeId', element: <CreativesLibraryPage /> }],
      },
      {
        path: 'create',
        element: <CreateCampaignPage />,
        children: [
          {
            path: ':campaignId',
            element: <CreateCampaignPage />,
            children: [
              { path: 'audiences', element: <CreateCampaignPage /> },
              {
                path: 'ads',
                element: <CreateCampaignPage />,
              },
              {
                path: 'political-transparency',
                element: <CreateCampaignPage />,
              },
              {
                path: 'settings',
                element: <CreateCampaignPage />,
              },
            ],
          },
        ],
      },

      {
        path: 'edit',
        element: <CreateCampaignPage />,
        children: [
          {
            path: ':campaignId',
            element: <CreateCampaignPage />,
            children: [
              { path: 'audiences', element: <CreateCampaignPage /> },
              {
                path: 'ads',
                element: <CreateCampaignPage />,
              },
              {
                path: 'political-transparency',
                element: <CreateCampaignPage />,
              },
              {
                path: 'settings',
                element: <CreateCampaignPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/reporting',
    children: [
      { path: 'matchback', element: <PlaceholderPage /> },
      { path: 'campaigns', element: <PlaceholderPage /> },
      { path: 'ip-targeting', element: <PlaceholderPage /> },
    ],
  },
  {
    path: '/report-hub/*',
    element: <ReportHubToAdvancedReportingRedirect />,
  },
  {
    path: '/advanced-reporting',
    children: [
      { index: true, element: <ReportHubRedirect /> },
      { path: 'overview', element: <ReportHubOverviewPage /> },
    ],
  },
  {
    path: '/orgs',
    children: [
      {
        path: ':orgId',
        children: [
          { path: 'child-orgs', element: <ChildOrgsPage /> },
          { path: 'org-settings', element: <OrgSettingsPage /> },
          { path: 'billing', element: <BillingPage /> },
        ],
      },
    ],
  },
  { path: '/search', element: <SearchPage /> },
  { path: '/documentation', element: <DocumentationPage /> },
  { path: '/internal-api-docs', element: <InternalAPIDocsPage /> },
  {
    path: 'pixel-library',
    element: <PixelLibraryPage />,
    children: [{ path: ':view', element: <PixelLibraryPage /> }],
  },
  {
    path: '/pixel-library/pixel/:pixelId/subscription/:subscriptionId',
    element: <PixelSubscriptionsPage />,
  },
  {
    path: '/pixel-library/publisher/:publisherId/subscription/:subscriptionId',
    element: <PixelSubscriptionsPage />,
  },
  {
    path: '/pixel-library/pixel/:pixelId',
    element: <PixelViewPage />,
  },
  {
    path: '/release-notes',
    element: <ReleaseNotePage />,
  },
  {
    path: '/aup',
    element: <AUPPage />,
  },
  {
    path: '/dpa',
    element: <DPAPage />,
  },
]
